import axios from "axios";
import GetServerAddress from "../../../../../functions/GetServerAddress";

export async function Get_Registers_Need_Reach_Part4_UserDefinedFields(
  options,
  setdata,
  logout
) {
  try {
    const response = await axios.post(
      GetServerAddress() +
        "api/staff/Get_Registers_Need_Reach_Part4_UserDefinedFields",
      {
        options: options,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
          username: localStorage.getItem("Username"),
          activitylog: "No",
        },
      }
    );
    // Check for specific server response indicating an invalid auth token
    if (response.data.status === 403 || response.data.status === 401) {
      logout();
      return; // Stop further execution in case of invalid auth token
    }
    console.log("Response Data: ", response);
    setdata(response.data.data); // Update your state with the fetched data
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}
